const blocklyToolboxIFKit = [
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_AUDIO}',
    categorystyle: 'audio_category',
    cssConfig: {
      icon: 'customIcon categoryIfkit categoryIfblock'
    },
    contents: [
      {
        kind: 'block',
        blockxml: `
            <block type="machine_ifzero_buzzer">
              <value name="PIN_NUMBER">
                <block type="math_number">
                  <field name="NUM">12</field>
                </block>
              </value>
              <value name="DUTY">
                <block type="math_number">
                  <field name="NUM">125</field>
                </block>
              </value>
              <value name="FREQUENCY">
                <block type="math_number">
                  <field name="NUM">1000</field>
                </block>
              </value>
            </block>`
      }
    ]
  },
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_LED}',
    categorystyle: 'led_category',
    cssConfig: {
      icon: 'customIcon categoryIfkit categoryIfblock'
    },
    contents: [
      {
        kind: 'block',
        type: 'common_color'
      },
      {
        kind: 'block',
        type: 'machine_ifzero_led'
      },
      {
        kind: 'block',
        blockxml: `
            <block type="machine_ifzero_rgbled_pin">
              <value name="LED_ID">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
              <value name="RED_PIN">
                <block type="math_number">
                  <field name="NUM">25</field>
                </block>
              </value>
              <value name="GREEN_PIN">
                <block type="math_number">
                  <field name="NUM">26</field>
                </block>
              </value>
              <value name="BLUE_PIN">
                <block type="math_number">
                  <field name="NUM">27</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="machine_ifzero_rgbled">
              <value name="COLOR">
                <block type="common_color">
                  <field name="COLOR">#ff6600</field>
                </block>
              </value>
              <value name="LED_ID">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
            </block>`
      }
    ]
  },
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_DISPLAY}',
    categorystyle: 'display_category',
    cssConfig: {
      icon: 'customIcon categoryIfkit categoryIfblock'
    },
    contents: [
      {
        kind: 'block',
        blockxml: `
            <block type="machine_ifzero_lcd_pin">
              <value name="RS">
                <block type="math_number">
                  <field name="NUM">19</field>
                </block>
              </value>
              <value name="EN">
                <block type="math_number">
                  <field name="NUM">22</field>
                </block>
              </value>
              <value name="D4">
                <block type="math_number">
                  <field name="NUM">7</field>
                </block>
              </value>
              <value name="D5">
                <block type="math_number">
                  <field name="NUM">8</field>
                </block>
              </value>
              <value name="D6">
                <block type="math_number">
                  <field name="NUM">4</field>
                </block>
              </value>
              <value name="D7">
                <block type="math_number">
                  <field name="NUM">5</field>
                </block>
              </value>
              <value name="COLS">
                <block type="math_number">
                  <field name="NUM">20</field>
                </block>
              </value>
              <value name="ROWS">
                <block type="math_number">
                  <field name="NUM">4</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="machine_ifzero_lcd_print">
              <value name="MESSAGE">
                <block type="text">
                  <field name="TEXT"></field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        type: 'machine_ifzero_lcd_control'
      },
      {
        kind: 'block',
        blockxml: `
            <block type="machine_ifzero_lcd_cursor">
              <value name="COL">
                <block type="math_number">
                  <field name="NUM">0</field>
                </block>
              </value>
              <value name="ROW">
                <block type="math_number">
                  <field name="NUM">0</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="machine_ifzero_lcd_char">
              <value name="CHAR_ID">
                <block type="math_number">
                  <field name="NUM">0</field>
                </block>
              </value>
            </block>`
      }
    ]
  },
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_MOTOR}',
    categorystyle: 'motor_category',
    cssConfig: {
      icon: 'customIcon categoryIfkit categoryIfblock'
    },
    contents: [
      {
        kind: 'block',
        blockxml: `
            <block type="machine_ifzero_servo">
              <value name="PIN_NUMBER">
                <block type="math_number">
                  <field name="NUM">14</field>
                </block>
              </value>
              <value name="DUTY">
                <block type="math_number">
                  <field name="NUM">50</field>
                </block>
              </value>
            </block>`
      }
    ]
  },
  {
    kind: 'category',
    name: '%{BKY_CATEGORY_SENSOR}',
    categorystyle: 'sensor_category',
    cssConfig: {
      icon: 'customIcon categoryIfkit categoryIfblock'
    },
    contents: [
      {
        kind: 'block',
        blockxml: `
            <block type="machine_ifzero_photoresistor">
              <value name="PIN_NUMBER">
                <block type="math_number">
                  <field name="NUM">37</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="machine_ifzero_ultrasonic">
              <value name="SONIC_ID">
                <block type="math_number">
                  <field name="NUM">1</field>
                </block>
              </value>
              <value name="TRIG_PIN">
                <block type="math_number">
                  <field name="NUM">21</field>
                </block>
              </value>
              <value name="ECHO_PIN">
                <block type="math_number">
                  <field name="NUM">22</field>
                </block>
              </value>
            </block>`
      },
      {
        kind: 'block',
        blockxml: `
            <block type="machine_ifzero_temp_hum">
              <value name="PIN_NUMBER">
                <block type="math_number">
                  <field name="NUM">15</field>
                </block>
              </value>
            </block>`
      }
    ]
  }
]

const ifkitAdd = {
  start_category: [
    {
      kind: 'block',
      blockxml: `
          <block type="machine_ifzero_gpio_button">
            <value name="PIN">
              <block type="math_number">
                <field name="NUM">33</field>
              </block>
            </value>
          </block>`
    }
  ]
}

export { blocklyToolboxIFKit, ifkitAdd }

export default {
  blocklyToolboxIFKit,
  ifkitAdd
}
